import React from 'react';
import {motion} from 'framer-motion';
import {useBrandKit} from '../contexts/BrandKitContext';
import ProcessDocumentCard from '../components/dashboard/ProcessDocumentCard';
import EffectiveBrandKit from '../components/dashboard/EffectiveBrandKit';
import AllBrandKits from '../components/dashboard/AllBrandKits';
import HowToUse from '../components/dashboard/HowToUse';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiRefreshCw} = FiIcons;

export default function Dashboard() {
  const {brandKits} = useBrandKit();

  return (
    <div className="bg-brand-bg min-h-full p-8 space-y-6">
      <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}}>
        <ProcessDocumentCard />
      </motion.div>
      
      <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{delay: 0.1}}>
        <div className="flex justify-between items-center text-sm text-gray-600 mb-4">
          <div className="flex items-center">
            <span className="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
            Connected to server • Last updated: {new Date().toLocaleTimeString()}
          </div>
          <div className="flex items-center">
            <span>{brandKits?.length || 0} brand kits loaded</span>
            <button className="flex items-center ml-4 text-blue-600 hover:underline">
              <SafeIcon icon={FiRefreshCw} className="w-4 h-4 mr-1" />
              Refresh from Server
            </button>
          </div>
        </div>
        <EffectiveBrandKit />
      </motion.div>
      
      <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{delay: 0.2}}>
        <AllBrandKits />
      </motion.div>
      
      <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{delay: 0.3}}>
        <HowToUse />
      </motion.div>
    </div>
  );
}